import { render, staticRenderFns } from "./home_insuranceauthorization_logo.svg?vue&type=template&id=5d849b35&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports